// PHASE 1: Social proof feedback on transformation vision
import FeedbackPage from '@app-studio-web/ui/pages/FeedbackPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

export default function TransformationVisionFeedbackPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  return (
    <FeedbackPage
      emoji="💫"
      heading={t('pages.onboarding.v2.transformationVisionFeedback.heading')}
      text={t('pages.onboarding.v2.transformationVisionFeedback.description')}
      onSubmit={handleSubmit}
    />
  )
}
